import { useContext, useState, useEffect } from 'react'
import { CompanyConfigContext } from '../../context api/Configuration/CompanyConfig'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'
import { UserContext } from '../../context api/UserContext'
import { useSubscription } from '../../hooks/SuperAdmin/useSubscription'

export const usePermissions = () => {
  const [permission, setPermissions] = useState(false)
  const { deleteNewPermission, getNewPermissions } = useContext(CompanyConfigContext)
  const [moduleName, setModuleName] = useState([]);
  const [actionName, setActionName ]= useState([]);
  const [mappedModules, setMappedModules] = useState({})
  const user = useContext(UserContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)
  const {  activeSubscriptions, active,  } = useSubscription()
  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Permissions', 'ALL_PERMISSIONS', 'GET_ALL_PERMISSIONS')
  const {
    PERMISSION: { GET_ALL_PERMISSIONS, ADD_PERMISSION, EDIT_PERMISSION, GET_PERMISSION, DELETE_MANY_PERMISSION },
  } = API_URL
  useEffect(()=>{
    activeSubscriptions();
  }, [])

  useEffect(()=>{
    if(active)
      getModules();
  }, [active])

  useEffect(()=>{
    // if(active)
    //   getModules();
  }, [mappedModules])
  const getModules = async ()=>{
    console.log("User Modules", active);
    
    console.log(active?.subscription?.modules)
    let tempModule = [], tempMappedModule = [], tempAction = []
    if(active.subscription?.modules){
      // allowedModules.map(allowedModule=>{
        active.subscription.modules.allowed.map(am=>{
          tempModule.push(am.module)
          tempAction.push(am.subPermission)
          tempMappedModule.push({[am.module] : am.subPermission})
        // })
      })
      setModuleName(tempModule);
      setActionName(tempAction);
      setMappedModules(tempMappedModule)
      // setAllowedFeatures(allowedModules);
    }
  }
  const getAllPermissions = async (dto = {}) => {
    console.log({ dto })
    GET_ALL(GET_ALL_PERMISSIONS, setPaginate, getNewPermissions, dto)
  }

  const addPermissions = (dto) => {
    ADD(ADD_PERMISSION, dto)
  }

  const updatePermissions = (dto) => {
    UPDATE(EDIT_PERMISSION, dto)
  }

  const getPermission = (dto) => {
    GET_SINGLE_DATA(GET_PERMISSION, setPermissions, dto.permissionId)
  }

  const deleteManyPermission = (dto, setSelected = () => {}) => {
    DELETE(DELETE_MANY_PERMISSION, dto, 'permissionId', setSelected, deleteNewPermission, 'GET_ALL_PERMISSIONS')
  }

  return {
    addPermissions,
    getAllPermissions,
    getPermission,
    permission,
    updatePermissions,
    deleteManyPermission,
    getModules,
    moduleName,
    actionName,
    mappedModules,
    loading,
    paginate,
  }
}
